module.exports = __webpack_public_path__ + "img/avatar-s-24.13572d01.png";